import React from 'react';

import Icon from '../../../components/ui/Icon';


const SocialRegistration = ({ onSocialRegister, loading = false }) => {
  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'bg-white border-border text-foreground hover:bg-muted'
    },
    {
      id: 'microsoft',
      name: 'Microsoft',
      icon: 'Square',
      color: 'bg-[#0078d4] text-white hover:bg-[#106ebe]'
    },
    {
      id: 'apple',
      name: 'Apple',
      icon: 'Apple',
      color: 'bg-black text-white hover:bg-gray-800'
    }
  ];

  const handleSocialRegister = async (provider) => {
    try {
      await onSocialRegister(provider);
    } catch (error) {
      console.error(`${provider} registration failed:`, error);
    }
  };

  return (
    <div className="space-y-4">
      {/* Divider */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-white/20" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-transparent font-body text-white/90 drop-shadow">
            Or continue with
          </span>
        </div>
      </div>

      {/* Social Buttons */}
      <div className="grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={() => handleSocialRegister('google')}
          disabled={loading}
          className="flex items-center justify-center space-x-2 px-4 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 rounded-lg font-body text-sm font-medium text-white transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
        >
          <Icon name="Chrome" size={18} />
          <span>Google</span>
        </button>

        <button
          type="button"
          onClick={() => handleSocialRegister('github')}
          disabled={loading}
          className="flex items-center justify-center space-x-2 px-4 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 rounded-lg font-body text-sm font-medium text-white transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
        >
          <Icon name="Github" size={18} />
          <span>GitHub</span>
        </button>
      </div>
    </div>
  );
};

export default SocialRegistration;